import m from "../../geodata/es2015/norwayLow";
window.am4geodata_norwayLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/norwayLow.js
// module id = null
// module chunks = 